// One place for tape-measure maths: parse what people type ("25 1/2", "25-1/2", "1/2", "25.5")
// into decimal inches, and format decimals back as reduced mixed fractions snapped to the shop's
// precision (1/8" or 1/16"). Values are always stored as decimals; only display changes.
const DEFAULTS = { fractional: true, precision: 16, metric: false };
let current = { ...DEFAULTS };

export const setMeasureDefaults = (general = {}) => {
  current = {
    fractional: general.fractional_inches !== false,
    precision: Number(general.fraction_precision) === 8 ? 8 : 16,
    metric: (general.measurement_system || "imperial") === "metric",
  };
};

export const measureDefaults = () => current;

export const parseInches = (raw) => {
  if (raw === null || raw === undefined) return null;
  if (typeof raw === "number") return Number.isFinite(raw) ? raw : null;
  let s = String(raw).trim().toLowerCase().replace(/["”″]|in(ch(es)?)?\b/g, "").trim();
  if (!s) return null;
  const neg = s.startsWith("-") && !/^-?\d+\s*-\s*\d+\/\d+$/.test(s);
  if (neg) s = s.slice(1).trim();
  // "25 1/2", "25-1/2", "25_1/2"
  let m = s.match(/^(\d+(?:\.\d+)?)\s*[-\s_]\s*(\d+)\s*\/\s*(\d+)$/);
  let v;
  if (m) {
    if (Number(m[3]) === 0) return null;
    v = Number(m[1]) + Number(m[2]) / Number(m[3]);
  } else if ((m = s.match(/^(\d+)\s*\/\s*(\d+)$/))) {
    if (Number(m[2]) === 0) return null;
    v = Number(m[1]) / Number(m[2]);
  } else if (/^\d*\.?\d+$/.test(s) || /^\d+\.$/.test(s)) {
    v = Number(s);
  } else return null;
  if (!Number.isFinite(v)) return null;
  return neg ? -v : v;
};

export const snapInches = (v, precision = current.precision) =>
  Math.round((Number(v) || 0) * precision) / precision;

// 25.5 → 25 1/2" · 25 → 25" · 0.5 → 1/2" · 70.13 → 70 1/8" (at 1/16 it is 70 1/8" too)
export const formatInches = (value, opts = {}) => {
  const o = { ...current, ...opts };
  const unit = o.unit === false ? "" : '"';
  const v = Number(value) || 0;
  if (o.metric) return `${Math.round(v * 25.4)}${o.unit === false ? "" : "mm"}`;
  if (!o.fractional) return `${Number(v.toFixed(2))}${unit}`;
  const sign = v < 0 ? "-" : "";
  const abs = Math.abs(v);
  let whole = Math.floor(abs);
  let num = Math.round((abs - whole) * o.precision);
  let den = o.precision;
  if (num === den) {
    whole += 1;
    num = 0;
  }
  if (num === 0) return `${sign}${whole}${unit}`;
  while (num % 2 === 0) {
    num /= 2;
    den /= 2;
  }
  return `${sign}${whole ? `${whole} ` : ""}${num}/${den}${unit}`;
};

export const fmtIn = (v, opts) => formatInches(v, opts);
